import React from 'react'
import { connect } from 'react-redux'

const styles = {
  root: {
    textAlign: 'center',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '500px',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
  },
}

class ImagePage extends React.Component {

  render() {
    const { mission_page } = this.props
    return (
      <div style={styles.root}>
        <img style={styles.image} src={mission_page.media_url} alt={`pagina nº: ${mission_page.id}`} />
      </div>
    )
  }

}

ImagePage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(ImagePage)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/ImagePage/index.jsx